import { DetailCard, DetailList, TabButton, TabProvider, TabPanel } from '@tecuity/granite-ui'
import React, { useEffect, useMemo, useState } from 'react'
import { Body } from '../../Shell/Shell'
import { useRequestData } from '../../../Utilities/hooks'
import {
  GET_APOSTILLE_RECORD_DETAILS,
  GET_APOSTILE_RECORD_DETAIL_SETTINGS,
} from '../../../requests'
import { useLocation } from 'react-router'
import { format } from 'date-fns'
import ApostilleHistoryPanel from './ApostilleHistoryPanel'
import { useDispatch } from 'react-redux'
import { SET_EXPANDABLE_HISTORY } from '../RecordDetailsReducer'
import { saveNewNote, getEntityNotes, editNote, deleteNote } from '../RecordDetailsActions'
import NotesPanel from '../NotesPanel'

const ApostilleRecordDetails = () => {
  const dispatch = useDispatch()
  const [showDrawer, setShowDrawer] = useState(false)
  const [activeTabId, setActiveTabId] = useState('tab-2')
  const location = useLocation()
  const apostilleNum = location.pathname.split('/').pop()
  const [loadingHistory /*setLoadingHistory*/] = useState(false)
  const data = useRequestData((cb, ecb) => GET_APOSTILLE_RECORD_DETAILS(apostilleNum, cb, ecb))
  const RecordDetailsSettings = useRequestData((cb, ecb) =>
    GET_APOSTILE_RECORD_DETAIL_SETTINGS(cb, ecb)
  )

  useEffect(() => {
    if (data && data.history) dispatch({ type: SET_EXPANDABLE_HISTORY, history: data.history })
  }, [data])

  const handleTabChange = (tabId) => {
    setActiveTabId(tabId)
    setShowDrawer(false)
    if (tabId) {
      window.setTimeout(() => {
        window.scroll()
      }, 300)
    }
  }

  const AddField = (fieldName, value, array) => {
    if (
      RecordDetailsSettings &&
      RecordDetailsSettings[fieldName] &&
      RecordDetailsSettings[fieldName].Enabled == true
    ) {
      array.push({ label: RecordDetailsSettings[fieldName].DisplayName, value: value })
    }
  }

  // two data objects for the two detail cards;
  const apostilleData = useMemo(() => {
    if (data === null) {
      return []
    }

    const dataArray = []
    AddField('SignedBy', data.SignedBy, dataArray)
    AddField('ApostilleNum', data.FilingNum, dataArray)
    if (data.LegacyDocumentNum) AddField('LegacyControlNum', data.LegacyDocumentNum , dataArray)
    AddField('NotaryNum', data.NotaryNum, dataArray)
    AddField('NotaryName', data.NotaryName, dataArray)
    AddField('Country', data.Country, dataArray)
    AddField('County', data.County, dataArray)
    AddField('ActingCapacity', data.ActingCapacityDescription, dataArray)
    AddField('DLN', data.DLN, dataArray)
    AddField('ReceivedDate', format(new Date(data.ReceivedDate || null), 'MM/dd/yyyy'), dataArray)
    AddField('CreatedDate', format(new Date(data.CreatedDate || null), 'MM/dd/yyyy'), dataArray)
    AddField('Status', data.Status, dataArray)
    return dataArray
  }, [data, RecordDetailsSettings])

  const requestorInformationData = useMemo(() => {
    if (data === null) {
      return []
    }

    const dataArray = []
    AddField('DocumentType', data.DocumentType, dataArray)
    AddField('ContactName', data.ContactName, dataArray)
    AddField('ContactPhone', data.ContactPhone, dataArray)
    AddField('ContactCountry', data.ContactCountry, dataArray)
    AddField(
      'ContactAddress',
      `${data.ContactAddr1 || ''} ${data.ContactAddr2 || ''} ${data.ContactAddr3 || ''}\n` +
        `${data.ContactCity || ''}, ${data.ContactState || ''} ${data.ContactPostalCode || ''} `,
      dataArray
    )

    return dataArray
  }, [data, RecordDetailsSettings])

  React.useEffect(() => {
    data && dispatch(getEntityNotes(720, data.ApostilleId))
  }, [data])

  const saveNewApostilleNote = (note) => {
    //720 is source type for apostille. We may want to make this more dynamic at some point
    dispatch(saveNewNote(note, 720, data.ApostilleId))
  }

  const editApostilleNote = (note) => {
    //720 is source type for apostille. We may want to make this more dynamic at some point
    dispatch(editNote(note, 720, data.ApostilleId))
  }

  const deleteApostilleNote = (noteId) => {
    //720 is source type for apostille. We may want to make this more dynamic at some point
    dispatch(deleteNote(noteId, 720, data.ApostilleId))
  }

  return (
    <Body className="no-padding" showDrawer={showDrawer}>
      <TabProvider activeTabId={activeTabId} onChange={(id) => handleTabChange(id)}>
        <div className="row header-row">
          <h1>Apostille Record Details</h1>
          <div className="tablist" role="tablist">
            <TabButton id="tab-1" forPanelId="panel-1" label="History" />
            <TabButton id="tab-2" forPanelId="panel-2" label="Notes" />
          </div>
        </div>

        <div
          className="row"
          style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginBottom: '20px' }}
        >
          <DetailCard className="detailsCard" label="Apostille" style={{ flexGrow: '1' }}>
            <DetailList className="detailsList" details={apostilleData} />
          </DetailCard>
          <DetailCard
            className="detailsCard"
            label="Requestor Information"
            style={{ flexGrow: '1' }}
          >
            <DetailList className="detailsList" details={requestorInformationData} />
          </DetailCard>
        </div>
        <TabPanel tabId="tab-1" id="panel-1">
          <h2>History</h2>
          <ApostilleHistoryPanel loadingHistory={loadingHistory} />
        </TabPanel>
        <TabPanel tabId="tab-2" id="panel-2">
          <NotesPanel 
            saveNote={saveNewApostilleNote} 
            editNote={editApostilleNote} 
            deleteNote={deleteApostilleNote}
          />
        </TabPanel>
      </TabProvider>
    </Body>
  )
}

export default ApostilleRecordDetails
